export default __webpack_public_path__ + "static/media/labels_price_reduced.2bd05486.jpg";